import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from 'react-bootstrap/lib/Grid';
import cns from 'classnames';
import BrandButton from '../../../../../BrandButton';

import cn from './styles.local.less';

export default class StickyFooter extends PureComponent {
  static propTypes = {
    isSticky: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { isSticky, onSubmit } = this.props;

    return (
      <div className={cn.root}>
        <div
          className={cns(cn.inner, { [cn.sticky]: isSticky })}
          data-qa-selector="footer-bar"
        >
          <Grid>
            <div className={cn.footer}>
              <BrandButton
                bsStyle="primary"
                className={cn.searchButton}
                data-qa-selector="submit-search"
                onClick={onSubmit}
                bsSize="small"
              >
                {__('search.extra.filters.submitBtnText')}
              </BrandButton>
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}
